import * as React from 'react';
import Radio from 'src/components/FormElements/Radio';
import { StatisticsFilters } from '../types';

type PeriodType = StatisticsFilters['period']['type'];

type PeriodEntry = {
  label: string;
  key: PeriodType;
}

type PeriodSelectProps = {
  value: PeriodType;
  onChange: (type: PeriodType) => void;
};

const types: PeriodEntry[] = [
  { key: 'month', label: 'Måned' },
  { key: 'half_year', label: 'Halvt år' },
  { key: 'year', label: 'År' },
  { key: 'year_to_date', label: 'År til dato' },
  { key: 'custom', label: 'Vælg periode' },
];

const PeriodSelect = ({ value, onChange }: PeriodSelectProps) => (
  <div className="flex flex-column">
    {types.map((type) => (
      <Radio
        key={type.key}
        value={type.key}
        name="periodType"
        className="mt1 cursor-pointer"
        checked={value === type.key}
        onChange={() => onChange(type.key)}
      >
        {type.label}
      </Radio>
    ))}
  </div>
);

export default PeriodSelect;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Reports/components/PeriodSelect.tsx